var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSellerSvg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_32_18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.6463 49.512C42.1391 49.512 53.0772 38.5541 53.0772 25.0368C53.0772 11.5195 42.1391 0.561523 28.6463 0.561523C15.1535 0.561523 4.21545 11.5195 4.21545 25.0368C4.21545 38.5541 15.1535 49.512 28.6463 49.512Z",
    fill: "url(#paint0_linear_32_18)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4129 15.4215C16.2855 13.3819 16.14 10.3225 18.9031 9.88542C25.1562 10.1768 32.1364 9.30268 38.3896 9.88542C39.4075 9.88542 40.2801 10.3225 40.7163 11.1966C41.1526 12.0707 42.1706 15.1301 42.1706 15.8585C42.1706 17.6068 42.0251 19.0636 40.2801 19.7921V20.0834V28.0962C41.4435 28.0962 42.1706 28.8246 42.316 29.8444C42.4614 30.8642 42.4614 34.215 42.316 35.2348C42.1706 36.2546 41.5889 36.4003 41.0072 36.6916H16.7217C16.14 36.4003 15.8492 35.9632 15.4129 35.3805V29.2617C15.8492 28.5332 16.4309 27.9505 17.4488 27.9505V20.0834C17.4488 19.5007 17.0126 19.6464 16.7217 19.355C16.14 18.7723 15.7038 18.3352 15.4129 17.6068V15.2758V15.4215ZM21.5206 10.6139H18.6122C18.6122 10.6139 17.7397 11.1966 17.5943 11.1966C16.8672 11.925 16.5763 14.1103 16.14 15.2758H20.6481L21.5206 10.6139ZM26.3196 10.6139H22.3932L21.5206 15.2758H26.0287L26.3196 10.6139ZM30.8277 10.6139H26.9013L26.6104 15.2758H30.9731V10.6139H30.8277ZM35.3357 10.6139H31.4093L31.7002 15.2758H36.2083L35.3357 10.6139ZM41.298 15.2758C40.8618 14.256 40.5709 11.925 39.8438 11.1966C39.1167 10.4682 38.8259 10.6139 38.8259 10.6139H35.9174L36.7899 15.2758H41.298ZM20.7935 16.0042H16.14C15.9946 17.7525 16.2855 19.355 18.3214 19.355C20.3573 19.355 21.0844 17.7525 20.7935 16.0042ZM26.0287 16.0042H21.5206C20.6481 20.6662 26.7558 20.5205 26.0287 16.0042ZM31.1185 16.0042H26.6104C26.465 17.7525 26.9013 19.5007 28.9372 19.355C30.9731 19.2093 31.2639 17.6068 31.1185 16.0042ZM36.0628 16.0042H31.5548C31.4093 17.7525 31.8456 19.355 33.8815 19.355C35.9174 19.355 36.2083 17.6068 36.0628 16.0042ZM41.4434 16.0042H36.7899C36.4991 17.7525 37.2262 19.5007 39.2621 19.355C41.298 19.355 41.5889 17.6068 41.4434 16.0042ZM19.4847 19.7921V28.0962H25.5925C25.447 25.4738 26.9013 24.5997 29.3734 24.7454C31.4093 24.7454 32.2819 26.0566 32.1365 28.0962H38.2442V19.7921C37.5171 19.7921 37.0808 19.0636 36.6445 18.6266C35.6266 20.5205 32.5727 20.5205 31.5548 18.6266C30.1005 20.5205 27.7738 20.3748 26.3196 18.6266C25.7379 20.0834 23.702 20.3748 22.3932 19.6464C21.0844 18.918 21.6661 18.918 21.2298 18.6266C20.939 19.2093 20.3573 19.6464 19.7756 19.7921H19.4847ZM18.7576 20.0834H18.0305V28.0962H18.7576V20.0834ZM39.553 20.0834H38.8259V28.0962H39.553V20.0834ZM31.2639 28.0962C31.5548 25.6195 30.246 25.1825 28.0646 25.4738C25.8833 25.7652 26.0287 26.6393 26.1741 28.0962H31.2639ZM41.298 29.553C41.298 29.116 40.8618 28.8246 40.4255 28.8246H17.0126C16.7217 28.8246 16.2855 29.116 16.2855 29.553H41.4434H41.298ZM41.4434 30.2815H15.9946V35.3805C15.9946 35.3805 16.7217 36.1089 16.8672 35.9632H40.8618C40.8618 35.8175 41.4434 35.3805 41.4434 35.3805V30.2815Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.1,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6822 22.5601C30.6822 23.5799 29.8097 24.454 28.7917 24.454C27.7738 24.454 26.9013 23.5799 26.9013 22.5601C26.9013 21.5403 27.7738 20.6662 28.7917 20.6662C29.8097 20.6662 30.6822 21.5403 30.6822 22.5601ZM29.9551 22.5601C29.9551 21.9774 29.3734 21.3946 28.7917 21.3946C28.2101 21.3946 27.6284 21.9774 27.6284 22.5601C27.6284 23.1429 28.2101 23.7256 28.7917 23.7256C29.3734 23.7256 29.9551 23.1429 29.9551 22.5601Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.1,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7361 34.3607C33.4453 34.652 33.009 34.7977 32.5727 34.7977C31.1185 34.9434 26.465 34.9434 25.0108 34.7977C22.9749 34.5064 22.9749 31.884 25.0108 31.5926C27.0467 31.3013 30.8277 31.4469 32.4273 31.5926C34.0269 31.7383 34.6086 33.3409 33.5907 34.3607H33.7361ZM24.8654 32.3211C23.9928 32.4667 23.9928 33.9236 24.8654 34.0693C25.7379 34.215 31.4093 34.215 32.5727 34.0693C33.7361 33.9236 33.5907 32.4667 32.5727 32.3211H24.7199H24.8654Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.1,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_32_18",
    x: 0.215454,
    y: 0.561523,
    width: 56.8618,
    height: 56.9505,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_32_18"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_32_18",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_32_18",
    x1: 53.0772,
    y1: 25.0368,
    x2: 4.21545,
    y2: 25.0368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB556B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#973E69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#622C66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#3B1E65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#231664"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1464"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSellerSvg);
export default __webpack_public_path__ + "static/media/iconSellerSvg.a5da3579acde0ae7c5140d5c5703469e.svg";
export { ForwardRef as ReactComponent };